<template>
    <div class="login-container">
        <!-- 左侧背景和文字 -->
        <div class="left-side" :class="loginType == 2?'reg-left':''">
            <div class="content" @click="goHome">
                <svg-icon icon-class="backblack" style="width: 34px;height: 34px;margin-right: 14px;" />
                <div>{{ loginType == 2 ? t('login34') : t('login33') }}</div>
            </div>
            <div class="content-phone" @click="goHome">
                <svg-icon icon-class="backblack" style="width: 20px;height: 20px;margin-right: 10px;" />
                <div>{{ loginType == 2 ? t('login34') : t('login33') }}</div>
            </div>
            <!-- <div v-show="loginType == 2" class="register-bg"><img src="@/assets/images/registerbg.png" alt="Image 1" />
            </div> -->
            <div>

            </div>
        </div>
        <!-- 右侧登录表单 -->
        <div class="right-side">
            <div class="none-box" :style="loginType == 2?'padding-top:calc(93% - 100px)':''"></div>
            <div class="form-container">
                <!-- <div class="type-change">222</div> -->
                <div class="gradient-text" @click="goHome">
                    <img src="@/assets/images/51shopylogo.png" alt="Image 1" />
                </div>
                <div class="login-type" v-if="loginType == 2">{{ $t("login1") }}<span @click="checkType(1)">{{
                    $t("login2") }}</span></div>
                <div class="login-type" v-else-if="loginType == 3">{{ $t("login3") }} <span @click="checkType(1)">{{
                    $t("login4") }}</span></div>

                <div class="title-list" v-if="loginType == 1 || loginType == 2">
                    <div @click="checkType(1)" :class="loginType == 1 ? 'sel-item' : ''">
                        <div :class="loginType == 1 ? 'sel-icon' : ''">
                            <div>
                                <div></div>
                            </div>
                        </div>
                        {{ t('login35') }}
                    </div>
                    <div @click="checkType(2)" :class="loginType == 2 ? 'sel-item' : ''">
                        <div :class="loginType == 2 ? 'sel-icon2' : ''">
                            <div>
                                <div></div>
                            </div>
                        </div>{{ t('login36') }}
                    </div>
                    <div class="sel-line" :style="loginType == 2 ? 'left:calc(75% - 6px)' : ''"></div>
                </div>
                <div class="login-content" v-if="loginType == 1">
                    <div class="account-box">

                        <loginView :loginType="loginType" @checkType="checkType" :ispopup="false"></loginView>

                    </div>
                </div>
                <div class="login-content" v-if="loginType == 2">
                    <div class="account-box">
                        <div class="form">
                            <el-form ref="registerRef" :model="state.registerForm" size="large" :rules="rulesRegister"
                                label-position="top" label-width="60px" status-icon>
                                <el-form-item prop="email" :label="''" class="form-item">
                                    <el-input v-model="state.registerForm.email" :placeholder="$t('login7')">
                                        <!-- <template #prefix>
                                            <svg-icon icon-class="email" />
                                        </template> -->
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="code" :label="''" class="form-item">
                                    <el-input class="reset-input" v-model="state.registerForm.code"
                                        :placeholder="$t('login9')">
                                        <!-- <template #prefix>
                                            <svg-icon icon-class="operate" />
                                        </template> -->
                                        <template #append>
                                            <el-button :loading="state.loading" :disabled="state.disabled"
                                                @click="registersend()">
                                                {{ state.text }}
                                            </el-button>
                                        </template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="password" :label="''" class="form-item">
                                    <el-input v-model="state.registerForm.password" type="password" show-password
                                        :placeholder="$t('login10')">
                                        <!-- <template #prefix>
                                            <svg-icon icon-class="password" />
                                        </template> -->
                                    </el-input>
                                </el-form-item>
                                <el-form-item :label="''" prop="newPwd">
                                    <el-input type="password" show-password v-model="state.registerForm.newPwd"
                                        :placeholder="$t('login12')" autocomplete="off">
                                        <!-- <template #prefix>
                                            <svg-icon icon-class="password" />
                                        </template> -->
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="invitationCode" :label="''" class="form-item">
                                    <el-input v-model="state.registerForm.invitationCode" :placeholder="$t('setup79')">
                                        <!-- <template #prefix>
                                            <svg-icon icon-class="Invitation" />
                                        </template> -->
                                    </el-input>
                                </el-form-item>
                                <el-button size="large" type="primary" class="subBtn" @click="register()">{{
                                    $t('login13') }}</el-button>
                            </el-form>
                        </div>
                    </div>
                </div>
                <div class="login-content" v-if="loginType == 3">
                    <div class="account-box">
                        <!-- <div class="retrieve-title">{{ $t("setup472") }}</div> -->
                        <div class="retrieve-title">{{ $t("login5") }}</div>
                        <div class="form" v-if="pwdtype == 1">
                            <el-form ref="ResetRef" :model="state.ResetForm" size="large" :rules="rulesEmail"
                                label-position="top" label-width="60px" status-icon>
                                <el-form-item prop="email" :label="''" class="form-item">
                                    <el-input v-model="state.ResetForm.email" :placeholder="$t('login7')">
                                        <!-- <template #prefix>
                                            <svg-icon icon-class="email" />
                                        </template> -->
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="code" :label="''" class="form-item">
                                    <el-input class="reset-input" v-model="state.ResetForm.code"
                                        :placeholder="$t('login9')">
                                        <!-- <template #prefix>
                                            <svg-icon icon-class="operate" />
                                        </template> -->
                                        <template #append>
                                            <el-button :loading="state.Resetloading" :disabled="state.Resetdisabled"
                                                @click="verifyRegister()">
                                                {{ state.Resettext }}
                                            </el-button>
                                        </template>
                                    </el-input>
                                </el-form-item>
                                <el-button size="large" type="primary" class="subBtn" @click="goNext">{{
                                    $t('login14')
                                }}</el-button>
                            </el-form>
                        </div>
                        <div class="from" v-else>
                            <el-form ref="ResetPwdRef" :model="state.ResetForm" size="large" :rules="rulspwd"
                                label-position="top" label-width="60px" status-icon>
                                <el-form-item prop="password" :label="''" class="form-item">
                                    <el-input v-model="state.ResetForm.password" type="password" show-password
                                        :placeholder="$t('login10')">
                                        <!-- <template #prefix>
                                            <svg-icon icon-class="password" />
                                        </template> -->
                                    </el-input>
                                </el-form-item>
                                <el-form-item :label="$t('login11')" prop="newPwd">
                                    <el-input type="password" show-password v-model="state.ResetForm.newPwd"
                                        :placeholder="''" autocomplete="off">
                                        <!-- <template #prefix>
                                            <svg-icon icon-class="password" />
                                        </template>--></el-input>
                                </el-form-item>
                                <el-button size="large" style="width: 100%;" type="primary" round class="subBtn"
                                    @click="submitPwd">{{
                                        $t('login15') }}</el-button>
                            </el-form>
                        </div>
                        <div class="login-bottom">
                            <div @click="checkType(1)">{{ $t("login2") }}</div>
                            <div @click="checkType(2)" class="btn-reg">{{ $t("login6") }}</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
       
    </div>

</template>

<script setup>
import loginView from '@/components/loginView/index.vue'
import { useMeta } from 'vue-meta';
import { sendCodeAPI, setPwdAPI, registerAPI } from '@/apis/user'
import { ElMessage } from 'element-plus'
import 'element-plus/theme-chalk/el-message.css'
import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/userStore'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n();
const userStore = useUserStore()
const route = useRouter();
const loginType = ref(1)

const showInstallButton = ref(false);
let deferredPrompt = null;
onMounted(() => {
    console.log('路由', route.currentRoute.value.fullPath)
    if (route.currentRoute.value.fullPath == '/login') {
        loginType.value = localStorage.getItem('loginType') || 1
    } else {
        localStorage.setItem('loginType', 2)
        loginType.value = 2
        let url = route.currentRoute.value.fullPath
        state.registerForm.invitationCode = url.split('?')[1]; // 截取 ? 后面的部分
    }

    useMeta({
        title: '登录',
        meta: [
            { name: 'keywords', content: '登录' },
            { name: 'description', content: '登录页面，注册页面，忘记密码' }
        ]
    });
  

})


const state = reactive({
    //发送验证码
    text: t('login16'),
    loading: false,
    disabled: false,
    duration: 60,
    timer: null,
    Resettext: t('login16'),
    Resetloading: false,
    Resetdisabled: false,
    Resetduration: 60,
    Resettimer: null,
    default: {
        text: t('login16'),
        duration: 60
    },
    verifiedModel: false,
    areaCodeList: [],

    registerForm: {
        email: '',
        password: '',
        code: null,
        newPwd: null,
        invitationCode: ""
    },
    ResetForm: {
        email: '',
        password: '',
        code: null,
        newPwd: null
    }
});
const ResetRef = ref()
const registerRef = ref()

const router = useRouter()
const ResetPwdRef = ref()
const pwdtype = ref(1)
const isEmail = ref(false)
/**
 * 下一步
 */
const goNext = () => {
    if (isEmail.value) {
        pwdtype.value = 2
    } else {

        ElMessage({ type: 'error', message: t('login17') })
    }

}
const checkType = (type) => {
    loginType.value = type
    localStorage.setItem('loginType', type)
}
const validatePass1 = (rule, value, callback) => {
    if (value === '') {
        callback(new Error(t('login12')));
    } else if (value !== state.ResetForm.password) {
        callback(new Error('login18'));
    } else {
        callback();
    }
};
const validatePass2 = (rule, value, callback) => {
    if (value === '') {
        callback(new Error(t('login12')));
    } else if (value !== state.registerForm.password) {
        callback(new Error(t('login18')));
    } else {
        callback();
    }
};


const verifyRegister = () => {

    ResetRef.value.validateField('email', async (valid) => {
        if (valid) {
            let data = {
                email: state.ResetForm.email,
                type: 2,//忘记密码
            }
            const res = await sendCodeAPI(data)

            if (res.code == 0) {
                isEmail.value = true
                Resetcountdown()
                ElMessage({ type: 'success', message: t('login19') })
            } else {
                ElMessage({ type: 'error', message: res.message })
            }

        }
    })

}

// 忘记密码倒计时
const Resetcountdown = () => {

    state.Resetdisabled = true;

    state.Resettimer && clearInterval(state.Resettimer);

    state.Resettimer = setInterval(() => {

        const tmp = state.Resetduration--;
        state.Resettext = `${tmp}s`;
        if (tmp <= 0) {
            clearInterval(state.Resettimer);
            state.Resetduration = state.default.duration;
            state.Resettext = state.default.text;
            state.Resetdisabled = false;
        }

    }, 1000);
}


const rulesEmail = {
    email: [
        { required: true, message: t('login20'), trigger: 'blur' },
        { type: 'email', message: t('login21'), trigger: 'blur' },

    ],
    code: [
        { required: true, message: t('login22'), trigger: 'blur' },
        { min: 4, max: 4, message: t('login23'), trigger: 'blur' }
    ],

}
const rulspwd = {
    password: [
        { required: true, message: t('login24'), trigger: 'blur' },
        { min: 6, message: t('login25'), trigger: 'blur' }
    ],
    newPwd: [
        { validator: validatePass1, trigger: 'blur' }
    ]
}
const submitPwd = () => {
    ResetPwdRef.value.validate(async (valid) => {
        if (valid) {
            let data = {
                email: state.ResetForm.email,
                code: parseInt(state.ResetForm.code),
                newPwd: state.ResetForm.password,
                confirmPwd: state.ResetForm.newPwd
            }
            const res = await setPwdAPI(data)

            if (res.code == 0) {

                ElMessage({ type: 'success', message: t('login26') })
                state.Resettext = 0
                loginType.value = 1
                checkType(1)
            } else {
                ElMessage({ type: 'error', message: res.message })
            }

        }
    })
}
// 倒计时
const countdown = () => {

    state.disabled = true;

    state.timer && clearInterval(state.timer);

    state.timer = setInterval(() => {

        const tmp = state.duration--;
        state.text = `${tmp}s`;
        if (tmp <= 0) {
            clearInterval(state.timer);
            state.duration = state.default.duration;
            state.text = state.default.text;
            state.disabled = false;
        }

    }, 1000);

};

//注册
const registersend = () => {
    state.verifiedModel = false
    countdown()
    registerRef.value.validateField('mobile', async (valid) => {
        if (valid) {
            let data = {
                email: state.registerForm.email,
                type: 1,//登录
            }
            const res = await sendCodeAPI(data)
            console.log(res)
            if (res.code == 0) {

                ElMessage({ type: 'success', message: t('login19') })
            } else {
                ElMessage({ type: 'error', message: res.message })
            }

        }
    })
};
const rulesRegister = {

    email: [
        { required: true, message: t('login20'), trigger: 'blur' },
        { type: 'email', message: t('login21'), trigger: 'blur' },

    ],
    password: [
        { required: true, message: t('login24'), trigger: 'blur' },
        { min: 6, message: t('login25'), trigger: 'blur' }
    ],
    code: [
        { required: true, message: t('login22'), trigger: 'blur' },
        { min: 4, max: 4, message: t('login23'), trigger: 'blur' }
    ],
    newPwd: [
        { validator: validatePass2, trigger: 'blur' }
    ]
}


const register = () => {
    registerRef.value.validate(async (valid) => {
        if (valid) {
            let data = {
                email: state.registerForm.email,
                password: state.registerForm.password,
                code: parseInt(state.registerForm.code),
                invitationCode: state.registerForm.invitationCode
            }
            const res = await registerAPI(data)
            console.log(res)
            if (res.code == 0) {

                ElMessage({ type: 'success', message: t('login27') })
                state.duration = 0
                loginType.value = 1
                checkType(1)
            } else {
                ElMessage({ type: 'error', message: res.message })
            }

        }
    })
}
const goHome = () => {
    router.push('/')
}
</script>


<style scoped lang='scss'>
/* 基本容器布局 */
.login-container {
    display: flex;
    height: 100vh;
}

.type-change {
    display: none;
}

.left-side,.reg-left {
    flex: 1;
    background-image: url('@/assets/images/login-bg1.png');

    // display: flex;
    // justify-content: center;
    // align-items: center;


    /* 背景图片覆盖整个容器，不留空白 */
    background-size: cover;

    /* 背景图片不平铺 */
    background-repeat: repeat;

    /* 确保背景图片始终居中显示 */
    background-position: center center;

    /* 设置容器高度，根据需要调整 */
    height: 100vh;

    /* 使容器中的其他内容在背景之上 */
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    .content,
    .content-phone {
        // height: 100%;
        // background-color: rgba(255, 255, 255, 0.2);
        // // backdrop-filter: blur(4px);
        // border-radius: 10px;
        // color: #fff;
        // box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        text-align: center;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        margin-top: 77px;

        >div {
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 24px;
            color: #7F3434;
            line-height: 31px;
            font-style: normal;
        }

    }

    .content-phone {
        display: none;
    }

    .register-bg {
        width: 80%;

        >img {
            width: 100%
        }
    }
}

.left-side .content {
    color: white;
    text-align: left;
    padding: 0 20px;
}
.reg-left {
    background-image: url('@/assets/images/regbg.png');
}
.right-side {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;

    .none-box {
        display: none;
    }

    .form-container {
        width: 500px;

        .login-type {
            // padding-left: 20px;
            font-size: $formSize;
            line-height: 19px;
            color: #A3A3A3;
            margin: 30px 0 20px 0;

            >span {
                color: #66a4fb;
            }
        }

        .gradient-text {

            // background: linear-gradient(to right, #56a9ff, #f56c6c, );
            // -webkit-background-clip: text;
            // color: transparent;
            // font-size: 50px;
            // // padding-left: 16px;
            // font-weight: 700;
            >img {
                width: 130px;
            }
        }

        .login-content {
            .login-bottom {
                display: none;
                // display: flex;
                // justify-content: space-between;
                // padding: 10px 20px;
                // color: #56a9ff;
                // font-size: $formSize;
            }

            .account-box {

                .form {
                    // padding: 20px;
                    // padding: 0 20px 20px 20px;

                    .form-item {
                        .input {
                            height: 44px;
                        }
                    }

                    .subBtn {
                        width: 100%;
                    }
                }


            }
        }


    }
}

.but {
    display: flex;

    padding: 10px;
    border-radius: 1px;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, .25);
    color: RGBA(0, 0, 0, 0.54);
    text-align: center;
    margin: 10px 0;
    width: 100%;
}

.title-list {
    display: none;
}

.retrieve-title {
    display: none;
}


/* 响应式设计 */
@media (max-width: 768px) {
    .login-container {
        flex-direction: column;
    }

    .left-side {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 55vh;
        // background-size: contain;
        background-size: 100% auto;
        background-repeat: no-repeat;
        background-position: top;
        .content {
            display: none;

        }

        .content-phone {
            text-align: center;
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            margin-top: 20px;
            margin-left: 30px;

            >div {
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 18px;
                color: #7F3434;
                line-height: 31px;
                font-style: normal;
            }
        }

        .register-bg {
            width: 80%;
            position: relative;
            top: -50px;

            >img {
                width: 100%
            }
        }

        // display: none;
        // height: 40vh;
        // background-position: center;
    }
    .right-side {
        flex: 1;
        display: block;
        // justify-content: center;
        // align-items: center;
        background: #ffffff;


        .none-box {
            display: block;
            width: 100%;
            height: 0;
            padding-top: calc(82% - 100px);
            // height: calc(55vh - 100px);
            // padding-top: 100%;
        }

        .form-container {
            background-color: #fff;
            z-index: 1;
            width: 90%;
            border-radius: 20px;
            margin: 0 auto 20px;
            position: relative;

            .title-list {
                border-top-left-radius: 20px;
                border-top-right-radius: 20px;
                background-color: #fce9e8;
                display: flex;
                align-items: center;
                height: 40px;
                margin-bottom: 10px;
                overflow: hidden;
                position: relative;

                >div {
                    text-align: center;
                    width: 50%;
                    height: 40px;
                    line-height: 40px;
                }

                .sel-item {
                    background-color: #fff;
                    position: relative;
                    border-top-left-radius: 20px;
                    border-top-right-radius: 20px;

                    .sel-icon,
                    .sel-icon2 {
                        position: absolute;
                        right: -20px;
                        bottom: 0;
                        background-color: #fff;
                        width: 20px;
                        height: 20px;
                        overflow: hidden;
                        transform: rotate(-90deg);

                        >div {
                            width: 40px;
                            height: 40px;

                            >div {
                                width: 40px;
                                height: 40px;
                                border-radius: 50%;
                                background-color: #fce9e8;
                            }
                        }
                    }

                    .sel-icon2 {
                        transform: rotate(180deg);

                        left: -20px;
                    }
                }

                .sel-line {
                    width: 12px;
                    height: 4px;
                    background: #FC3938;
                    border-radius: 2px;
                    position: absolute;
                    bottom: 0;
                    left: calc(25% - 6px);
                }
            }

            .type-change {
                background-color: #fce9e8;
                display: block;
                background-image: url('@/assets/images/card-bg.png');
                background-size: cover;

                /* 背景图片不平铺 */
                background-repeat: repeat;

                /* 确保背景图片始终居中显示 */
                background-position: left top;
                width: 100%;
                height: 150px;
            }

            .login-type {
                display: none;
                // padding-left: 20px;
                font-size: $formSize;
                line-height: 19px;
                color: #A3A3A3;
                margin: 30px 0 20px 0;

                >span {
                    color: #66a4fb;
                }
            }

            .gradient-text {
                display: none;
                background: linear-gradient(to right, #56a9ff, #f56c6c, );
                -webkit-background-clip: text;
                color: transparent;
                font-size: 40px;
                // padding-left: 16px;
                font-weight: 700;
            }

            .login-content {
                .login-bottom {

                    display: flex;
                    justify-content: space-between;
                    padding: 10px 20px;
                    color: #56a9ff;
                    // font-size: $formSize;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    line-height: 14px;
                    font-style: normal;
                }

                .account-box {
                    .form {
                        padding: 20px;
                        // padding: 0 20px 20px 20px;

                        .form-item {
                            .input {
                                height: 44px;
                            }
                        }

                        // .subBtn {
                        //     width: 100%;
                        // }
                        .subBtn {
                            height: 52px;
                            width: 100%;
                            border-radius: 26px;
                        }
                    }


                }
            }


        }
    }

    .retrieve-title {
        display: block;
        padding: 40px 20px 0;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 19px;
        color: #11192D;
        line-height: 16px;
        text-align: left;
        font-style: normal;
    }

    :deep(.el-input-group__append) {

        border-top-right-radius: 26px;
        border-bottom-right-radius: 26px;
    }

    :deep(.el-input__wrapper) {
        // position: relative;
        // top:-1px;
        // left: 0;
        height: 52px;
        border-radius: 26px;
        overflow: hidden;
        background-color: #f4f5f6;
    }

    :deep(.reset-input .el-input__wrapper) {
        // position: relative;
        // top:-1px;
        // left: 0;
        height: 52px;
        border-radius: 26px;
        overflow: hidden;
        background-color: #f4f5f6;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;

    }

}
</style>